
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useTranslation } from "react-i18next";
import { append as append_1, ofArray, singleton as singleton_1, tryFind, contains, filter, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { createObj, safeHash, equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Select, MultiSelect } from "../../Components/Select.js";
import { defaultArgWith, map as map_1, toArray, bind, orElse, unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { BusinessUnitId__get_unwrap, FormKind as FormKind_1, FormState__getValidation } from "../../Shared/Shared.js";
import { BookingScope, Permissions_bookingScope, PermissionScope, Permission, Permissions_scopeAtLeast, RolePermissionsDto, RoleDefinitionModule_legacyRole, RoleDefinitionModule_isAssignable } from "../../Shared/Roles.js";
import { getQueryParams, roleDisplayName } from "../../Common.js";
import { exists, empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { RadioButton } from "../../Components/RadioButton.js";
import { Msg } from "./Types.js";
import { AutoSuggestInput, Input } from "../../Components/Input.js";
import { FormContainer } from "../../Components/FormContainer.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ErrorAlert } from "../../Components/Alert.js";
import { Checkbox } from "../../Components/Checkbox.js";
import { Feature, isFeatureEnabled } from "../../FeatureFlip.js";
import { BusinessUnitMultiSelect } from "../../Widgets/BusinessUnitSelect.js";
import { Hierarchy_getPath } from "../../Shared/Location.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { AllowUserToSubcontractorTransfer } from "../../Shared/User.js";
import { TooltipProps, Tooltip } from "../../SharedComponents/ReactTooltip.js";
import { NewsletterConsent } from "../../Widgets/NotificationSettings.js";
import { NewReceiverCustomProperties } from "../../Widgets/CustomProperties.js";
import { PropertyConfigurationVisibility } from "../../Shared/PropertyConfiguration.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { initEdit, update as update_1, initNew } from "./State.js";
import { RouterModule_trySeparateLast, RouterModule_encodeQueryString, RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { Skeleton } from "../../Components/Skeleton.js";

function StorageSelect(props) {
    const t = useTranslation()[0];
    const options = map((d) => ({
        label: d.Name,
        value: d,
    }), filter((s) => !contains(s.Id, map((selectedStorage) => selectedStorage.value.Id, props.SelectedStorages), {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }), props.Storages));
    return createElement(MultiSelect, {
        ComponentState: props.ComponentState,
        IsClearable: false,
        Label: t(props.LabelTranslationKey),
        NoOptionsMessage: "user.select_storage_no_options",
        OnChange: props.OnChange,
        Options: options,
        PlaceholderKey: "select.employee_placeholder",
        TestId: "user-storage",
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "storage")),
        Value: props.SelectedStorages,
    });
}

function selectedRoleDefinition(roles, selectedRoleId, user) {
    const assignableRoles = filter(RoleDefinitionModule_isAssignable, roles);
    return orElse(bind((roleId) => tryFind((role) => equals(role.Id, roleId), assignableRoles), selectedRoleId), tryFind((role_1) => {
        if (role_1.SystemKey != null) {
            return RoleDefinitionModule_legacyRole(role_1) === user.Role;
        }
        else {
            return false;
        }
    }, assignableRoles));
}

function rolePermissions(role) {
    return new RolePermissionsDto(role.Id, role.Name, role.SystemKey, role.Permissions);
}

function roleManagesStorages(role) {
    return Permissions_scopeAtLeast(rolePermissions(role), new Permission(2, []), new PermissionScope(3, []));
}

function roleBooksByStorageRules(role) {
    if (equals(Permissions_bookingScope(rolePermissions(role), new Permission(6, [])), new BookingScope(1, []))) {
        return true;
    }
    else {
        return equals(Permissions_bookingScope(rolePermissions(role), new Permission(7, [])), new BookingScope(1, []));
    }
}

function RoleSelect(props) {
    const t = useTranslation()[0];
    const options = map((role) => ({
        label: roleDisplayName(t, role),
        value: role,
    }), filter(RoleDefinitionModule_isAssignable, props.Roles));
    const selectedElement = bind((role_1) => tryFind((o) => equals(o.value.Id, role_1.Id), options), selectedRoleDefinition(props.Roles, props.SelectedRoleId, props.User));
    return createElement(Select, {
        ComponentState: props.ComponentState,
        IsClearable: false,
        Label: t("general.role"),
        NoOptionsMessage: "user.role_select_no_options_message",
        OnChange: props.OnChange,
        Options: options,
        PlaceholderKey: "select.employee_placeholder",
        TestId: "user-role",
        Value: unwrap(selectedElement),
    });
}

export function LoginInformation(props) {
    const t = useTranslation()[0];
    const user = props.User;
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const xs_1 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(singleton_1((elems = toList(delay(() => append((props.AccountSettings.SsoEnabled && props.CustomerConfiguration.SSOConfiguration.SSOActive) ? singleton(createElement(RadioButton, {
            ComponentState: componentState,
            Label: t("user.sso_user"),
            OnSelect: (arg) => {
                props.Dispatch(new Msg(12, [arg]));
            },
            Selected: props.User.SSOEnabled,
        })) : empty(), delay(() => append(singleton(createElement(RadioButton, {
            ComponentState: componentState,
            Label: t("user.login_with_email"),
            OnSelect: (_arg) => {
                props.Dispatch(new Msg(11, [false]));
            },
            Selected: !props.User.SSOEnabled && (!(user.LoginInformation.tag === 1)),
        })), delay(() => singleton(createElement(RadioButton, {
            ComponentState: componentState,
            Label: t("user.login_with_phone_number"),
            OnSelect: (_arg_1) => {
                props.Dispatch(new Msg(11, [true]));
            },
            Selected: !props.User.SSOEnabled && (!(user.LoginInformation.tag === 0)),
        })))))))), ["children", reactApi.Children.toArray(Array.from(elems))]))))), delay(() => {
            const matchValue_2 = user.LoginInformation;
            return (matchValue_2.tag === 0) ? singleton(createElement(Input, {
                ComponentState: componentState,
                Label: t("general.email"),
                OnChange: (arg_2) => {
                    props.Dispatch(new Msg(2, [arg_2]));
                },
                TestId: "user-email",
                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "email")),
                Value: matchValue_2.fields[0],
            })) : singleton(createElement(Input, {
                ComponentState: componentState,
                Label: t("user.phone_number"),
                OnChange: (arg_1) => {
                    props.Dispatch(new Msg(3, [arg_1]));
                },
                TestId: "user-phone-number",
                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "phoneNumber")),
                Value: matchValue_2.fields[0],
            }));
        }));
    }));
    return react.createElement(react.Fragment, {}, ...xs_1);
}

export function UserForm(props) {
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const selectedRole = selectedRoleDefinition(props.Roles, props.SelectedRoleId, props.User);
    const managesStorages = exists(roleManagesStorages, toArray(selectedRole));
    const booksByStorageRules = exists(roleBooksByStorageRules, toArray(selectedRole));
    return createElement(FormContainer, {
        Children: toList(delay(() => {
            let matchValue;
            return append((matchValue = FormState__getValidation(props.FormState, t, "global"), (matchValue == null) ? singleton(defaultOf()) : singleton(createElement(ErrorAlert, {
                Label: matchValue,
            }))), delay(() => append(equals(props.FormKind, new FormKind_1(0, [])) ? singleton(createElement(LoginInformation, {
                AccountSettings: props.AccountSettings,
                CustomerConfiguration: props.CustomerConfiguration,
                Dispatch: props.Dispatch,
                FormState: props.FormState,
                User: props.User,
            })) : empty(), delay(() => append((((equals(props.FormKind, new FormKind_1(1, [])) && (!(props.User.LoginInformation.tag === 1))) && props.AccountSettings.SsoEnabled) && props.CustomerConfiguration.SSOConfiguration.SSOActive) ? singleton(Checkbox({
                ComponentState: componentState,
                IsChecked: props.User.SSOEnabled,
                Label: t("user.sso_user"),
                OnCheck: (arg) => {
                    props.Dispatch(new Msg(12, [arg]));
                },
                TestId: "user-sso-user",
            })) : empty(), delay(() => append(singleton(createElement(Input, {
                ComponentState: componentState,
                Label: t("general.name"),
                OnChange: (arg_1) => {
                    props.Dispatch(new Msg(4, [arg_1]));
                },
                TestId: "user-name",
                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "name")),
                Value: props.User.Name,
            })), delay(() => append(singleton(createElement(Input, {
                ComponentState: componentState,
                Label: t("user.personnel_number"),
                OnChange: (arg_2) => {
                    props.Dispatch(new Msg(0, [arg_2]));
                },
                TestId: "user-personnel-number",
                Value: props.User.PersonnelNumber,
            })), delay(() => append(isFeatureEnabled(new Feature(17, [])) ? (props.AccountSettings.BusinessUnitsEnabled ? singleton(createElement(BusinessUnitMultiSelect, {
                BusinessUnits: props.BusinessUnits,
                FormState: props.FormState,
                OnChange: (value) => {
                    props.Dispatch(new Msg(14, [value]));
                },
                SelectedBusinessUnitIds: map(BusinessUnitId__get_unwrap, props.User.BusinessUnitIds),
            })) : empty()) : empty(), delay(() => {
                let dependencies_1;
                return append(singleton((dependencies_1 = [props.User.Department, props.DepartmentSuggestions, componentState], reactApi.useMemo(() => createElement(AutoSuggestInput, {
                    ComponentState: componentState,
                    Label: t("user.department"),
                    OnChange: (arg_3) => {
                        props.Dispatch(new Msg(1, [arg_3]));
                    },
                    Suggestions: props.DepartmentSuggestions,
                    TestId: "user-department",
                    Value: props.User.Department,
                }), dependencies_1))), delay(() => {
                    let Label_4, Options, Value_3, matchValue_2, locationId;
                    return append(singleton(createElement(Select, (Label_4 = t("general.location"), (Options = map((location) => ({
                        label: Hierarchy_getPath(props.Locations, location),
                        value: location,
                    }), props.Locations), (Value_3 = ((matchValue_2 = props.User.LocationId, (matchValue_2 == null) ? undefined : ((locationId = matchValue_2, map_1((location_3) => ({
                        label: Hierarchy_getPath(props.Locations, location_3),
                        value: location_3,
                    }), tryFind((location_2) => equals(location_2.Id, locationId), props.Locations)))))), {
                        ComponentState: componentState,
                        IsClearable: true,
                        Label: unwrap(Label_4),
                        NoOptionsMessage: "select.location_no_options",
                        OnChange: (location_1) => {
                            props.Dispatch(new Msg(13, [map_1((_arg_2) => _arg_2.value.Id, location_1)]));
                        },
                        Options: Options,
                        PlaceholderKey: "select.location_placeholder",
                        TestId: "user-location",
                        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "location")),
                        Value: unwrap(Value_3),
                    }))))), delay(() => append(singleton(createElement(RoleSelect, {
                        ComponentState: componentState,
                        OnChange: (arg_4) => {
                            props.Dispatch(new Msg(5, [arg_4]));
                        },
                        Roles: props.Roles,
                        SelectedRoleId: unwrap(props.SelectedRoleId),
                        User: props.User,
                    })), delay(() => append(managesStorages ? singleton(createElement(StorageSelect, {
                        ComponentState: componentState,
                        FormState: props.FormState,
                        LabelTranslationKey: "general.storage",
                        OnChange: (value_1) => {
                            if (value_1 == null) {
                            }
                            else {
                                props.Dispatch(new Msg(9, [ofArray(value_1)]));
                            }
                        },
                        SelectedStorages: props.SelectedAssignedStorageIds,
                        Storages: props.Storages,
                    })) : empty(), delay(() => append((booksByStorageRules && !props.CustomerConfiguration.GlobalSelfServiceStorageActive) ? singleton(createElement(StorageSelect, {
                        ComponentState: componentState,
                        FormState: props.FormState,
                        LabelTranslationKey: "general.self_service_storage",
                        OnChange: (value_3) => {
                            if (value_3 == null) {
                            }
                            else {
                                props.Dispatch(new Msg(10, [ofArray(value_3)]));
                            }
                        },
                        SelectedStorages: props.SelectedSelfServiceStorageIds,
                        Storages: props.Storages,
                    })) : empty(), delay(() => {
                        let elems_1, elems;
                        return append(booksByStorageRules ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "pt-5"])], (elems_1 = [Checkbox({
                            ComponentState: componentState,
                            IsChecked: equals(props.User.AllowUserToSubcontractorTransfer, new AllowUserToSubcontractorTransfer(0, [])),
                            Label: t("user.user_to_subcontractor"),
                            OnCheck: (arg_5) => {
                                props.Dispatch(new Msg(6, [arg_5]));
                            },
                            TestId: "user-allowed-user-to-subcontractor",
                        }), reactElement("div", createObj(ofArray([["className", join(" ", ["ml-2", "pt-5"])], (elems = [createElement(Tooltip, {
                            props: ofArray([new TooltipProps(4, [true]), new TooltipProps(0, ["user.user_to_subcontractor_tool_tip"])]),
                        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty(), delay(() => append(singleton(createElement(NewsletterConsent, {
                            FormState: componentState,
                            OnChangeNewsletterConsent: props.OnChangeNewsletterConsent,
                            User: props.User,
                        })), delay(() => (props.IsCustomPropertiesEnabled ? singleton(createElement(NewReceiverCustomProperties, {
                            Currency: props.CustomerConfiguration.Currency,
                            CustomProperties: props.User.CustomProperties,
                            FormState: props.FormState,
                            OnSetCustomProperty: (arg_6) => {
                                props.Dispatch(new Msg(7, [arg_6]));
                            },
                            PropertyConfigurationType: new PropertyConfigurationVisibility(2, []),
                            PropertyConfigurations: props.PropertyConfigurations,
                        })) : empty())))));
                    }))))))));
                }));
            }))))))))))));
        })),
        FormState: props.FormState,
        Header: props.Header,
        OnBack: props.OnBack,
        OnSave: props.OnSave,
    });
}

export function NewUserView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initNew, update_1, (_arg, _arg_1) => {
    }), props.AccountSettings, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const matchValue = state_1.Form;
    const matchValue_1 = state_1.CustomerConfiguration;
    const matchValue_2 = state_1.IsCustomPropertiesEnabled;
    const matchValue_3 = state_1.PropertyConfigurations;
    const matchValue_4 = state_1.DepartmentSuggestions;
    const matchValue_5 = state_1.Storages;
    const matchValue_6 = state_1.Locations;
    const matchValue_7 = state_1.BusinessUnits;
    const matchValue_8 = state_1.Roles;
    let matchResult, businessUnits, configuration, departmentSuggestions, isCustomPropertiesEnabled, locations, propertyConfigurations, roles, storages, user;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_5.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_6.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_7.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_8.tag === 0) {
        matchResult = 1;
    }
    else if (state_1.RoleAssignment.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        businessUnits = matchValue_7.fields[0];
        configuration = matchValue_1.fields[0];
        departmentSuggestions = matchValue_4.fields[0];
        isCustomPropertiesEnabled = matchValue_2.fields[0];
        locations = matchValue_6.fields[0];
        propertyConfigurations = matchValue_3.fields[0];
        roles = matchValue_8.fields[0];
        storages = matchValue_5.fields[0];
        user = matchValue.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(UserForm, {
                AccountSettings: props.AccountSettings,
                BusinessUnits: businessUnits,
                CustomerConfiguration: configuration,
                DepartmentSuggestions: departmentSuggestions,
                Dispatch: dispatch,
                FormKind: new FormKind_1(0, []),
                FormState: state_1.FormState,
                Header: patternInput_1[0]("user.create_new_user"),
                IsCustomPropertiesEnabled: isCustomPropertiesEnabled,
                Locations: locations,
                OnBack: () => {
                    RouterModule_nav(ofArray(props.OnBackPath), 1, 1);
                },
                OnChangeNewsletterConsent: (arg_1) => {
                    dispatch(new Msg(8, [arg_1]));
                },
                OnSave: () => {
                    dispatch(new Msg(15, []));
                },
                PropertyConfigurations: propertyConfigurations,
                Roles: roles,
                SelectedAssignedStorageIds: user.SelectedAssignedStorages,
                SelectedRoleId: unwrap(user.RoleId),
                SelectedSelfServiceStorageIds: user.SelectedSelfServiceStorages,
                Storages: storages,
                User: user.User,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

export function EditUserView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram((tupledArg) => initEdit(tupledArg[0], tupledArg[1]), update_1, (_arg, _arg_1) => {
    }), [props.UserId, props.AccountSettings], undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const matchValue = state_1.Form;
    const matchValue_1 = state_1.CustomerConfiguration;
    const matchValue_2 = state_1.IsCustomPropertiesEnabled;
    const matchValue_3 = state_1.PropertyConfigurations;
    const matchValue_4 = state_1.DepartmentSuggestions;
    const matchValue_5 = state_1.Storages;
    const matchValue_6 = state_1.Locations;
    const matchValue_7 = state_1.BusinessUnits;
    const matchValue_8 = state_1.Roles;
    let matchResult, businessUnits, configuration, departmentSuggestions, isCustomPropertiesEnabled, locations, propertyConfigurations, roles, storages, user;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_5.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_6.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_7.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_8.tag === 0) {
        matchResult = 1;
    }
    else if (state_1.RoleAssignment.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        businessUnits = matchValue_7.fields[0];
        configuration = matchValue_1.fields[0];
        departmentSuggestions = matchValue_4.fields[0];
        isCustomPropertiesEnabled = matchValue_2.fields[0];
        locations = matchValue_6.fields[0];
        propertyConfigurations = matchValue_3.fields[0];
        roles = matchValue_8.fields[0];
        storages = matchValue_5.fields[0];
        user = matchValue.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(UserForm, {
                AccountSettings: props.AccountSettings,
                BusinessUnits: businessUnits,
                CustomerConfiguration: configuration,
                DepartmentSuggestions: departmentSuggestions,
                Dispatch: dispatch,
                FormKind: new FormKind_1(1, []),
                FormState: state_1.FormState,
                Header: patternInput_1[0]("user.edit_user"),
                IsCustomPropertiesEnabled: isCustomPropertiesEnabled,
                Locations: locations,
                OnBack: () => {
                    const xs = ofArray(props.OnBackPath);
                    const queryString = getQueryParams(undefined);
                    defaultArgWith(map_1((tupledArg_1) => {
                        RouterModule_nav(append_1(tupledArg_1[0], singleton_1(tupledArg_1[1] + RouterModule_encodeQueryString(queryString))), 1, 1);
                    }, RouterModule_trySeparateLast(xs)), () => {
                        RouterModule_nav(singleton_1(RouterModule_encodeQueryString(queryString)), 1, 1);
                    });
                },
                OnChangeNewsletterConsent: (arg_1) => {
                    dispatch(new Msg(8, [arg_1]));
                },
                OnSave: () => {
                    dispatch(new Msg(16, []));
                },
                PropertyConfigurations: propertyConfigurations,
                Roles: roles,
                SelectedAssignedStorageIds: user.SelectedAssignedStorages,
                SelectedRoleId: unwrap(user.RoleId),
                SelectedSelfServiceStorageIds: user.SelectedSelfServiceStorages,
                Storages: storages,
                User: user.User,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

